<template>
    <TableBodyRow>
        <TableBodyRowCell>
            <span
                class="text-xs cursor-pointer hover:underline"
                @click="isDawerOpen = true"
            >
                {{ job.id }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.jobKey }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.jobState }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.queueName }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.createdAt }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.retriesCounter }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <div
                v-if="job.jobState === 'Failed'"
                class="flex justify-end items-center gap-1"
            >
                <form
                    method="POST"
                    :action="retryJobUrl"
                    :id="`retry-job-${job.id}`"
                >
                    <Button
                        :form="`retry-job-${job.id}`"
                        size="small"
                        color="light"
                        iconName="arrow-rotate"
                    ></Button>
                </form>
            </div>
        </TableBodyRowCell>
    </TableBodyRow>

    <Drawer
        :show="isDawerOpen"
        @close="isDawerOpen = false"
        width="wide"
    >
        <template #title>
            <span class="font-semibold"> Queue Job Info </span>
        </template>

        <template #content>
            <div class="space-y-4">
                <div>
                    <div class="text-sm">Payload</div>
                    <pre
                        class="max-h-80 text-xs overflow-auto p-4 border border-stone-300 rounded-lg"
                    >
                        {{ job.payload }}
                    </pre>
                </div>
                <div>
                    <div class="text-sm">Tags</div>
                    <pre
                        class="max-h-80 text-xs overflow-auto p-4 border border-stone-300 rounded-lg"
                    >
                        {{ job.tags }}
                    </pre>
                </div>
                <div>
                    <div class="text-sm">Error</div>
                    <pre
                        class="max-h-80 text-xs overflow-auto p-4 border border-stone-300 rounded-lg"
                    >
                        {{ job.errors }}
                    </pre>
                </div>
            </div>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import { type ProcessedQueueJobData } from '@/Shared/AutoGenerated/Main'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    const props = defineProps({
        job: {
            type: Object as PropType<ProcessedQueueJobData>,
            required: true,
        },
        selectedQueueName: {
            type: String,
            required: true,
        },
        selectedJobState: {
            type: String,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
    })

    const retryJobUrl = new UrlFactory().makeAdminQueueRetryUrl(
        props.job.id,
        props.selectedJobState,
        props.selectedQueueName,
        props.currentPage,
    )

    const isDawerOpen = ref(false)
</script>
